var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fileService } from "./FileService";
export class FileBase {
    constructor(fileId) {
        this.fileId = fileId;
        fileService.add(this);
    }
    getUrl() {
        return this.url;
    }
    getOrCreateUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.url) {
                return this.url;
            }
            return yield this.createUrl();
        });
    }
    createUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.getData();
            if (!data)
                return undefined;
            if (!(data instanceof Blob))
                return undefined;
            this.url = URL.createObjectURL(data);
            fileService.registerUrl(this.fileId, this.url);
            return this.url;
        });
    }
}
